<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">   

      <h1 class="title center__text">ENVOI SMS EVÉNEMENTIEL</h1>
           <img class="card__image" src="/../images/environment.png" alt="" />
      <p>
        La communication joue un rôle essentiel dans le domaine de l'événementiel. Servicesms.sn met à votre disposition 
        les outils nécessaires pour améliorer votre stratégie marketing et garantir le succès de vos événements.
      </p>
      <p>
        Grâce à l'envoi automatique de SMS, vous gagnez du temps en envoyant des invitations, des informations ou des
        formulaires d'inscription à vos contacts ciblés ! Vous pouvez ainsi communiquer rapidement, efficacement et à
        moindre coût sur vos événements.
      </p>
      <p>
        L'envoi de SMS en masse vous permet également de savoir rapidement qui sera présent, ce qui facilite l'organisation
        globale. Avec notre plateforme, vous pouvez consulter les réponses à vos messages, ainsi que les statistiques liées 
        à l'ouverture du SMS ou au nombre de clics sur votre lien.
      </p>
      <p>
        Avec Servicesms.sn, vous pouvez promouvoir vos événements en toute autonomie et simplicité ! Nos solutions vous aident
        également à optimiser votre organisation et à minimiser vos efforts pour obtenir des résultats maximaux.
      </p>
      <h2>
        L'envoi de SMS peut être utile dans différentes situations liées à l'événementiel. 
      </h2>
      
        <li>Envoi d'invitations pour des soirées, des salons, des séminaires <br /></li>
        <li>Envoi d'invitations pour des mariages, des baptêmes, des anniversaires<br /></li>
        <li>Relance des visiteurs préinscrits à un événement <br /></li>
        <li>Relance des participants inscrits à des conférences<br /></li>
        <li>Remerciement aux visiteurs et exposants après un salon<br /></li>
        <li>Prospection pour la location de salles ou autres lieux<br /></li>
        <li>Communication avec les fournisseurs</li>
      
      <h2>Quelques exemples de SMS :</h2>
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/evenementiel-1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/evenementiel-2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/evenementiel-3.png" />
        </div>
      </div>
    </section>
     <SideNav/>

    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
